// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__8jkWp","inputWrap":"CustomTip_inputWrap__1DWKc"};